import React, { useState } from "react";
import profile_Img from "../../../../../../../Assets/Images/multipleUsers.png";
import { CgSpinner } from "react-icons/cg";

const ChatListItem = ({
  key,
  channel,
  onChannelSelect,
  followChannel,
  channelActiveChat,
  totalFollowers,
  setIsMessageLoading,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const IsFollowed = channel?.users?.some(
    (subscriber) => subscriber?._id === (localStorage.getItem("userId") || "")
  );

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();

    if (date.toDateString() === today.toDateString()) {
      // show time
      return date.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } else {
      // return date in MM-DD-YYYY format
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    }
  };

  return (
    <li
      className={`flex justify-between items-center p-3 px-2 mt-1.5 rounded-xl border transition cursor-pointer ${channel?._id === channelActiveChat?._id
        ? "bg-indigo-600 border-slate-700 shadow-lg"
        : "bg-white dark:bg-slate-900 border-zinc-100 dark:border-slate-700 hover:bg-[#F9F7FF] dark:hover:bg-slate-700"
        }`}
      onClick={() => {
        if (channel?._id === channelActiveChat?._id) {
          return;
        }
        setIsMessageLoading(true);
        onChannelSelect(channel);
      }}
      key={key}
    >
      {/* Left: Image + Info */}
      < div className="flex items-start w-full" >
        {
          channel?.mediaId?.imageUrl ? (
            <img
              src={channel.mediaId.imageUrl}
              alt={channel.channelName}
              className="max-w-[46px] max-h-[46px] rounded-full min-w-[46px] min-h-[46px] object-cover object-center"
            />
          ) : (
            <div
              className="w-[46px] h-[46px] flex items-center justify-center rounded-full shadow-sm shrink-0"
              style={{
                background:
                  "linear-gradient(to bottom right, rgb(139 92 246), rgb(217 70 239))",
              }}
            >
              <span className="text-white font-bold text-lg">
                {channel.channelName
                  ? channel.channelName
                    .split(" ")
                    .map((word) => word[0])
                    .join("")
                    .toUpperCase()
                    .slice(0, 2)
                  : "#"}
              </span>
            </div >
          )}

        <div className="flex flex-col ml-2 w-full overflow-hidden">
          {/* Top Row: Name + Time */}
          <div className="flex justify-between items-center w-full">
            <span
              className={`font-semibold text-sm truncate ${channel?._id === channelActiveChat?._id
                ? "text-white max-w-[180px]"
                : !IsFollowed
                  ? "text-black dark:text-zinc-100 max-w-[140px]"
                  : "text-black dark:text-zinc-100 max-w-[180px]"
                }`}
            >
              {channel.channelName}
            </span>
            {channel?.latestMessage?.sentTime && (
              <span
                className={`text-xs ml-2 whitespace-nowrap ${channel?._id === channelActiveChat?._id
                  ? "text-zinc-300"
                  : "text-[#7C7C7C] dark:text-zinc-400"
                  }`}
              >
                {formatDate(channel?.latestMessage?.sentTime)}
              </span>
            )}
          </div>

          {/* Bottom Row: Message or followers */}
          <div className="flex justify-between items-center w-full mt-1.5">
            <span
              className={`text-xs truncate ${channel?._id === channelActiveChat?._id
                ? "text-zinc-200"
                : "text-[#7C7C7C]"
                } ${IsFollowed ? "max-w-60" : "max-w-[200px]"
                }`}
            >
              {IsFollowed
                ? channel?.latestMessage?.messageType === "LOCATION"
                  ? "Location"
                  : channel?.latestMessage?.cipherText ??
                  channel?.latestMessage?.fileType ??
                  `${totalFollowers} follower${totalFollowers > 1 ? "s" : ""}`
                : `${totalFollowers} follower${totalFollowers > 1 ? "s" : ""}`}
            </span>
            {/* Unseen message count */}
            {channel?.unseenMessageCount > 0 && IsFollowed && (
              <span
                className={`
      bg-[#06B300] text-white text-[10px] font-semibold ml-2
      flex items-center justify-center h-4 px-1 rounded-md
      ${channel.unseenMessageCount > 9 ? "min-w-[1.2rem]" : "w-4"}
    `}
              >
                {channel.unseenMessageCount > 99
                  ? "99+"
                  : channel.unseenMessageCount}
              </span>
            )}
          </div>
        </div>
      </div >

      {/* Right Side: Follow button for unfollowed channels */}
      {
        !IsFollowed && (
          <button
            disabled={isLoading}
            onClick={async (ev) => {
              ev.stopPropagation();
              setIsLoading(true);
              await followChannel(channel);
              setIsLoading(false);
            }}
            className="ml-3 text-sm px-4 py-1.5 bg-white rounded-full border border-[#EBEBEB] text-black hover:text-white hover:bg-[var(--primary-color)]"
          >
            {isLoading ? (
              <CgSpinner className="animate-spin h-4 w-4 mx-auto" />
            ) : (
              "Follow"
            )}
          </button>
        )
      }
    </li >
  );
};

export default ChatListItem;
